
import { h, Fragment } from 'preact'

import './style.less'

export default ({ open }) => {

	const className = open === true && 'burger burger is-open' || 'burger'

	return (
		<span class={className}>
			<>
			<span class="burger__line burger__top"></span>
			<span class="burger__line burger__middle"></span>
			<span class="burger__line burger__bottom"></span>
			</>
		</span>
	)	
}